import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet } from 'react-native';
import {
  I18n,
  Utils,
  Container,
  FormFooter,
  Navigation,
  CheckButtonList,
  SimpleHeader,
} from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';
import { resetStatus } from '../../employer/actions';

export default memo(
  connect(
    function (state, ownProps) {
      return {
        saveOccHealthStatus: state.screens.employer.saveOccHealthStatus,
        errorMessage: state.screens.employer.errorMessage,
        occHealthMasterDepartments: state.screens.employer.occHealthMasterDepartmentsData,
        occHealthDepartments: state.screens.employer.occHealthDepartmentsData,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators({ resetStatus }, dispatch),
      };
    }
  )(function (props) {
    //loop through occHealthMasterDepartments and create array of objects with checked value
    // based on occHealthDepartments
    const mappedDepartments = Object.keys(props.occHealthMasterDepartments)
      .map((key) => {
        const department = props.occHealthMasterDepartments[key];
        const isDepartmentSelected = Object.values(props.occHealthDepartments).some(
          (d) => d.master_department_id === department.master_department_id
        );
        if (isDepartmentSelected) {
          return null; // Skip the department if it is already selected
        }
        return {
          label: department.name,
          id: department.master_department_id,
          checked: false,
          editable: true,
        };
      })
      .filter(Boolean); // Remove any null values from the array
    const [selectedDepartments, setDepartments] = useState(mappedDepartments || []);

    useEffect(
      function () {
        if (props.saveOccHealthStatus === SUCCESS) {
          Navigation.dismissAllModals();
        }
      },
      [props.saveOccHealthStatus]
    );
    useEffect(function () {
      return function () {
        props.actions.resetStatus();
      };
    }, []);

    function handleCancel() {
      Navigation.dismissAllModals();
    }

    function handleSave() {
      const ret = selectedDepartments.filter((d) => d.checked);
      props.onSave({ departmentIds: ret.map((d) => d.id) });
    }

    function handleDepartmentsSelection(departments) {
      setDepartments(departments);
    }

    const footer = (
      <FormFooter
        onCancel={handleCancel}
        onSave={handleSave}
        //   saveDisabled={!text?.trim()}
        cancelLabel="Cancel"
        saveLabel="Add"
      />
    );

    return (
      <Container
        scrollView={false}
        style={THEME.container}
        stickyFooter={footer}
        renderActivityOverlay={props.saveOccHealthStatus === REQUESTING}
        errorMessage={props.errorMessage?.message}
      >
        <View style={styles.listContainer}>
          <SimpleHeader label={`Select all the shops you'd like to add to your base`} />
          <CheckButtonList
            items={selectedDepartments}
            multi={true}
            scrollable={false}
            onValuesChanged={handleDepartmentsSelection}
          />
        </View>
      </Container>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    alignItems: 'center',
    paddingBottom: 40,
  },
  inputContainer: {
    width: '100%',
    maxWidth: 400,
    flex: 1,
    borderWidth: 1.5,
    borderRadius: 10,
    borderColor: 'rgb(170,170,170)',
    backgroundColor: COLOR.contrast,
    padding: 10,
    paddingHorizontal: 15,
  },
  input: {
    ...THEME.input,
    ...FONT.regular,
    fontSize: __WEB__ ? 12 : 12,
  },
});
